import { Component, Input, Output, EventEmitter } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CallbackType, FocusInputType, LocalService, PaymentGatewayOrderStatus, QrType, RazorPayCustomerResponse, QrGenerateRequest, Status, SupportingType, PaymentGatewayServiceType } from 'src/service/local.service';
import { PaymentManagementService } from 'src/service/payment-management.service';
import { QrPaymentService } from 'src/service/qr-payment.service';
import { WsUserService } from 'src/service/ws/ws-user.service';
import { EmitResponse } from 'src/service/ws/wsSupporting/wsEntities';
import { EmitType, RegisterName } from 'src/service/ws/wsSupporting/wsTypes';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-payment-qr-image',
  templateUrl: './payment-qr-image.component.html',
  styleUrl: './payment-qr-image.component.scss'
})
export class PaymentQrImageComponent {
  @Input() businessId: string = '';
  @Input() configId: string = '';
  @Input() gatewayType: PaymentGatewayServiceType = PaymentGatewayServiceType.RandomOrNone;
  @Input() receiverName: string = '';
  @Input() senderName: string = '-';
  @Input() amount: number = null;
  @Input() isGenerateQr: boolean = false;
  @Input() amountInputId: string = '';
  @Input() qrType: QrType;
  @Input() supportingId: string = '000000000000000000000000';
  @Input() supportingType: SupportingType = SupportingType.TestMode;
  @Input() isShowTestCallBack: boolean = true;

  @Output() isGenerateQrChange = new EventEmitter();
  @Output() onPaymentProccesed = new EventEmitter();

  razorpayWrapper: RazorPayCustomerResponse;
  qrUrl: string = ''; currentPaymentId: string = ''; referenceId: string = ''; processId: string = '';
  paymentUrl: string = ''; sanitizedUrl: SafeResourceUrl;
  htmlId: string = ''; elementIds: any;

  constructor(public localService: LocalService, private paymentService: PaymentManagementService, private wsUserService: WsUserService, private qrPaymentService: QrPaymentService, private sanitizer: DomSanitizer) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      success: 'payment_qr_success_' + this.htmlId,
      failed: 'payment_qr_failed_' + this.htmlId,
      payment_url: 'payment_url_' + this.htmlId
    };
  }

  ngOnInit() {
    this.onCheckWsBusinesEmitDetection();
    this.onLoad();
  }

  ngOnChanges(): void {
    if (this.isGenerateQr) {
      this.onGenerateQr();
    }
  }

  onLoad() {
    if (this.isShowTestCallBack && environment.current_environment_name == 'Production') {
      this.isShowTestCallBack = false;
    }

    switch (this.gatewayType) {
      case PaymentGatewayServiceType.RazorPay: {
        if (!(this.razorpayWrapper && this.razorpayWrapper.Id && this.razorpayWrapper.Id.length > 5)) {
          this.paymentService.getPaymentGatewayCustomer(this.businessId).subscribe(result => {
            this.razorpayWrapper = result;

            if (this.isGenerateQr) {
              this.onGenerateQr();
            }
          });
        }
      } break;
    }
  }

  onGenerateQr() {
    if (!this.receiverName || this.receiverName.length < 2) {
      this.receiverName = this.localService.getBusinessName(this.businessId).value;
    }

    switch (this.gatewayType) {
      case PaymentGatewayServiceType.RazorPay: {
        this.onGenerateQrRazorPay();
      } break;
      default: {
        this.onGenerateQrConfig();
      } break;
    }
  }

  onGenerateQrConfig() {
    this.onReset();

    const request = {
      businessId: this.businessId,
      gatewayType: this.gatewayType,
      configIdOrFundAccountId: this.configId,
      amount: this.amount,
      supportingId: this.supportingId,
      supportingType: this.supportingType,
      appUrl: environment.url.app
    } as QrGenerateRequest;

    this.qrPaymentService.generateQrCode(request).subscribe(result => {
      if (result.statusWithId.status == Status.Success) {
        this.referenceId = result.content.v1;
        this.processId = result.statusWithId.id;
        this.qrUrl = result.statusWithId.value;
        //this.sanitizedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(result.value);
        //this.paymentUrl = result.value;
      } else {
        this.localService.showInformationByStatus(result.statusWithId.status, true);
        this.onClose();
      }
    });
  }

  onIframeLoad() {
    const iframeEl = document.querySelector(this.elementIds.payment_url) as HTMLIFrameElement;

    if (iframeEl) {
      const currentUrl = iframeEl.contentWindow?.location.href;

      if (currentUrl && currentUrl === environment.url.app) {
        this.onClose();
      }
    }
  }

  onAction(index: number) {
    switch (index) {
      case 1: {
        this.onClose();
      } break;
      case 2: {
        //Success callback
        this.onUpdateStatus(true);
      } break;
      case 3: {
        //Failed callback
        this.onUpdateStatus(false);
      } break;
      case 4: {
        //Failed callback
        this.onRefreshPaymentStatus();
      } break;
    }
  }

  onRefreshPaymentStatus() {
    this.qrPaymentService.getQrPaymentLogStatusById(this.processId).subscribe(result => {
      if (result.status != Status.None) {
        this.localService.showInformationByStatus(result.status);
        switch (result.status) {
          case Status.Success: {
            this.onPaymentProccesed.emit(Status.Success);
            this.onClose();
          } break;
          default: {
            this.onClose();
          } break;
        }
      }
    });
  }

  onClose() {
    this.paymentUrl = '';
    this.qrUrl = '';
    this.isGenerateQr = false;
    this.isGenerateQrChange.emit();
  }

  onReset() {
    this.paymentUrl = '';
    this.referenceId = '';
    this.processId = '';
  }

  onUpdateStatus(isSuccess: boolean) {
    const orderStatus = isSuccess ? PaymentGatewayOrderStatus.Success : PaymentGatewayOrderStatus.Failed;
    this.paymentService.updatePaymentGatewayResponse(CallbackType.Qr, this.processId, orderStatus, this.businessId).subscribe(result => {

    });
  }

  onGenerateQrRazorPay() {
    this.onReset();

    if (this.razorpayWrapper.Id) {

      if (this.razorpayWrapper && this.razorpayWrapper.Id && this.razorpayWrapper.Id.length > 5) {
        if (!this.amount || this.amount <= 0) {
          this.localService.showInformation(this.localService.languageContent.common.amount_required, true);
          if (this.amountInputId && this.amountInputId.length > 3) {
            this.localService.onFocusNextInput(this.amountInputId, FocusInputType.TextBox);
          }
          this.onClose();
        } else {
          const request: QrGenerateRequest = {
            configIdOrFundAccountId: this.razorpayWrapper.FundAccount.Id,
            businessId: this.businessId,
            supportingId: this.supportingId,
            supportingType: this.supportingType,
            amount: this.amount,
            customerId: this.razorpayWrapper.FundAccount.CustomerId,
            name: this.receiverName,
            qrType: this.qrType ?? this.razorpayWrapper.QrType,
            gatewayType: this.gatewayType
          } as QrGenerateRequest;

          this.qrPaymentService.generateQrCode(request).subscribe(result => {
            if (result.statusWithId.status == Status.Success) {
              this.referenceId = result.content.v1;
              this.processId = result.statusWithId.id;
              this.qrUrl = result.statusWithId.value;
            } else {
              this.localService.showInformationByStatus(result.statusWithId.status, true);
              this.onClose();
            }
          });
        }
      }
    } else {
      this.localService.showMessage(this.localService.languageContent.common.no_qr_config_available);
      this.onClose();
    }
  }

  onCheckWsBusinesEmitDetection() {
    this.wsUserService.onEmitDetected(RegisterName.BusinessEmitDetected).subscribe((res: EmitResponse) => {
      switch (res.emitType) {
        case EmitType.PaymentProccesed: {
          const paymentStatus: PaymentGatewayOrderStatus = res.result.status;
          if (res.result.processId == this.processId) {
            const status = paymentStatus == PaymentGatewayOrderStatus.Success ? Status.Success : Status.Failed;
            this.onPaymentProccesed.emit(status);
            this.localService.showInformationByStatus(status);
            this.onClose();
          }
        } break;
        case EmitType.QrTypeUpdated: {
          this.razorpayWrapper.QrType = res.result.qrType;
        } break;
      }
    });
  }
}
